<script lang="ts">
	import { onMount, onDestroy } from "svelte";
	import type { SlideDeck } from "./slideData";
	import Reveal from "reveal.js";
	import "reveal.js/dist/reveal.css";
	import "reveal.js/dist/theme/white.css";

	let { deck, embedded = false }: { deck: SlideDeck; embedded?: boolean } = $props();

	let container: HTMLElement;
	let reveal: any;
	let styleEl: HTMLStyleElement | null = null;

	// --- Custom speaker view (lightweight, no iframes — reliable in an SPA) ---
	let speakerWin: Window | null = null;

	const SPEAKER_HTML = `<!doctype html><html><head><meta charset="utf-8"><title>Speaker View — Livewire</title>
<style id="spk-chrome">
  :root { color-scheme: dark; }
  * { box-sizing: border-box; }
  html, body { margin:0; background:#0f0f1e !important; }
  body { font-family:'DM Sans',system-ui,sans-serif; color:#e8e8f0; height:100vh; display:flex; flex-direction:column; overflow:hidden; }
  .spk-header { display:flex; align-items:center; justify-content:space-between; padding:12px 20px; border-bottom:1px solid rgba(255,255,255,0.08); flex:0 0 auto; }
  .spk-header .pos { font-size:13px; color:#9898b0; font-weight:600; letter-spacing:0.04em; }
  .spk-header .timer { font-variant-numeric:tabular-nums; font-size:28px; font-weight:700; color:#E8491C; }
  .spk-header button { background:transparent; border:1px solid rgba(255,255,255,0.15); color:#9898b0; border-radius:6px; padding:4px 10px; font-size:12px; cursor:pointer; margin-left:10px; }
  .spk-grid { flex:1; display:grid; grid-template-columns:1.5fr 1fr; gap:18px; padding:16px 20px; overflow:hidden; min-height:0; }
  .spk-col { display:flex; flex-direction:column; min-height:0; }
  .spk-label { font-size:11px; text-transform:uppercase; letter-spacing:0.1em; color:#E8491C; font-weight:700; margin:0 0 6px; }
  .spk-preview { position:relative; width:100%; aspect-ratio:1200/700; overflow:hidden; background:#1a1a2e; border-radius:8px; border:1px solid rgba(255,255,255,0.10); flex:0 0 auto; }
  .spk-scaler { position:absolute; top:0; left:0; width:1200px; height:700px; transform-origin:top left; pointer-events:none; }
  .spk-scaler .reveal.pv, .spk-scaler .reveal.pv .slides { width:1200px; height:700px; position:relative; }
  .spk-scaler .reveal.pv .slides > section { position:absolute !important; inset:0 !important; display:flex !important; flex-direction:column; justify-content:center; opacity:1 !important; visibility:visible !important; transform:none !important; }
  .spk-scaler .reveal.pv .slides > section .fragment { opacity:1 !important; visibility:visible !important; }
  .spk-notes { flex:1; overflow-y:auto; font-size:23px; line-height:1.5; color:#f0f0f5; margin-top:10px; }
  .spk-notes .empty { color:#6b6b80; font-style:italic; font-size:18px; }
  .spk-notes p { margin:0 0 0.7em; }
  .spk-notes i { color:#9898b0; font-style:italic; }
  .spk-notes b { color:#ffffff; }
  .spk-notes hr { border:none; border-top:1px solid rgba(255,255,255,0.12); margin:14px 0; }
  .spk-next-title { font-size:14px; font-weight:600; color:#c8c8d4; margin:10px 0 4px; }
  .spk-next-notes { font-size:14px; line-height:1.45; color:#9898b0; overflow-y:auto; }
  .spk-footer { display:flex; gap:12px; padding:10px 20px; border-top:1px solid rgba(255,255,255,0.08); flex:0 0 auto; }
  .spk-footer button { flex:1; background:rgba(232,73,28,0.12); border:1px solid rgba(232,73,28,0.3); color:#e8e8f0; border-radius:8px; padding:10px; font-size:14px; font-weight:600; cursor:pointer; }
</style></head>
<body>
  <div class="spk-header">
    <span class="pos" id="pos">— / —</span>
    <div><span class="timer" id="timer">00:00</span><button id="reset">Reset</button></div>
  </div>
  <div class="spk-grid">
    <div class="spk-col">
      <div class="spk-label">Current slide</div>
      <div class="spk-preview"><div class="spk-scaler" id="curScaler"></div></div>
      <div class="spk-label" style="margin-top:12px;">Speaker notes</div>
      <div class="spk-notes" id="notes"></div>
    </div>
    <div class="spk-col">
      <div class="spk-label">Next up</div>
      <div class="spk-preview"><div class="spk-scaler" id="nextScaler"></div></div>
      <div class="spk-next-title" id="nextTitle"></div>
      <div class="spk-next-notes" id="nextNotes"></div>
    </div>
  </div>
  <div class="spk-footer">
    <button id="prev">&larr; Previous</button>
    <button id="next">Next &rarr;</button>
  </div>
  <script>
    var start = Date.now(), DARK = true;
    function pad(n){ return (n<10?'0':'')+n; }
    function tick(){ var s=Math.floor((Date.now()-start)/1000); document.getElementById('timer').textContent = pad(Math.floor(s/60))+':'+pad(s%60); }
    setInterval(tick,250); tick();
    document.getElementById('reset').onclick=function(){ start=Date.now(); tick(); };
    function nav(dir){ if(window.opener && !window.opener.closed) window.opener.postMessage({type:'spk-nav',dir:dir},'*'); }
    document.getElementById('prev').onclick=function(){ nav('prev'); };
    document.getElementById('next').onclick=function(){ nav('next'); };
    window.addEventListener('keydown', function(e){
      if(e.key==='ArrowRight'||e.key==='PageDown'||e.key===' '){ e.preventDefault(); nav('next'); }
      else if(e.key==='ArrowLeft'||e.key==='PageUp'){ e.preventDefault(); nav('prev'); }
    });
    function frame(html){ return '<div class="'+(DARK?'dark-theme':'')+'"><div class="reveal pv"><div class="slides">'+(html||'')+'</div></div></div>'; }
    function fit(id){ var sc=document.getElementById(id); if(!sc||!sc.parentElement) return; sc.style.transform='scale('+(sc.parentElement.clientWidth/1200)+')'; }
    function fitAll(){ fit('curScaler'); fit('nextScaler'); }
    window.addEventListener('resize', fitAll);
    window.addEventListener('message', function(e){
      var d=e.data; if(!d || d.type!=='spk') return;
      DARK = !!d.dark;
      document.getElementById('pos').textContent = d.pos;
      document.getElementById('notes').innerHTML = (d.notes && d.notes.trim()) ? d.notes : '<span class="empty">No notes for this slide</span>';
      document.getElementById('nextTitle').textContent = d.nextTitle;
      document.getElementById('nextNotes').innerHTML = d.nextNotes || '';
      document.getElementById('curScaler').innerHTML = frame(d.curHTML);
      document.getElementById('nextScaler').innerHTML = d.nextHTML ? frame(d.nextHTML) : '';
      fitAll();
    });
    if(window.opener && !window.opener.closed) window.opener.postMessage({type:'spk-ready'},'*');
  <\/script>
</body></html>`;

	const slideTitle = (el: Element | null, slides: Element[]): string => {
		if (!el) return 'End';
		const h = el.querySelector('h1, h2, h3');
		const t = h?.textContent?.trim();
		return t && t.length ? t : `Slide ${slides.indexOf(el) + 1}`;
	};
	const slideNotes = (el: Element | null): string =>
		(el?.querySelector('aside.notes') as HTMLElement | null)?.innerHTML ?? '';

	// Clone a slide's markup for the preview: drop transition transforms and notes.
	const slideHTML = (el: Element | null): string => {
		if (!el) return '';
		const clone = el.cloneNode(true) as HTMLElement;
		clone.style.transform = '';
		clone.removeAttribute('hidden');
		clone.removeAttribute('aria-hidden');
		clone.querySelectorAll('aside.notes').forEach((n) => n.remove());
		return clone.outerHTML;
	};

	const pushToSpeaker = () => {
		if (!speakerWin || speakerWin.closed || !reveal) return;
		const slides: Element[] = reveal.getSlides();
		const cur: Element = reveal.getCurrentSlide();
		const idx = Math.max(0, slides.indexOf(cur));
		const next = slides[idx + 1] ?? null;
		speakerWin.postMessage({
			type: 'spk',
			dark: !!deck.darkTheme,
			pos: `${idx + 1} / ${slides.length}`,
			notes: slideNotes(cur),
			nextTitle: next ? slideTitle(next, slides) : 'End of deck',
			nextNotes: slideNotes(next),
			curHTML: slideHTML(cur),
			nextHTML: slideHTML(next),
		}, '*');
	};

	const onMainMessage = (e: MessageEvent) => {
		const d = e.data;
		if (!d || typeof d !== 'object') return;
		if (d.type === 'spk-ready') pushToSpeaker();
		else if (d.type === 'spk-nav' && reveal) {
			if (d.dir === 'next') reveal.next();
			else reveal.prev();
		}
	};

	// Copy the deck's stylesheets into the popup so cloned slides render correctly.
	const copyStylesToSpeaker = () => {
		if (!speakerWin) return;
		const doc = speakerWin.document;
		document.querySelectorAll('style, link[rel="stylesheet"]').forEach((n) => {
			try { doc.head.appendChild(doc.importNode(n, true)); } catch { /* ignore */ }
		});
		doc.body.style.background = '#0f0f1e';
	};

	const openSpeaker = () => {
		if (speakerWin && !speakerWin.closed) { speakerWin.focus(); return; }
		speakerWin = window.open('', 'lvwr-speaker', 'width=1280,height=860');
		if (!speakerWin) return; // popup blocked
		speakerWin.document.open();
		speakerWin.document.write(SPEAKER_HTML);
		speakerWin.document.close();
		copyStylesToSpeaker();
	};

	// Hidden access to the speaker view: type the code word.
	// Uses only reveal-safe letters (avoid n p h j k l f s b o), so no key-swallowing needed.
	const SECRET = 'matrix';
	let typed = '';
	const onSecretKey = (e: KeyboardEvent) => {
		const t = e.target as HTMLElement | null;
		if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
		if (e.key.length !== 1) return; // ignore arrows, etc.
		typed = (typed + e.key.toLowerCase()).slice(-SECRET.length);
		if (typed === SECRET) { typed = ''; openSpeaker(); }
	};

	onMount(() => {
		if (deck.customCSS) {
			styleEl = document.createElement('style');
			styleEl.textContent = deck.customCSS;
			document.head.appendChild(styleEl);
		}

		reveal = new Reveal(container, {
			embedded: embedded,
			controls: !embedded,
			progress: false,
			hash: false,
			keyboard: !embedded,
			touch: !embedded,
			loop: false,
			autoSlide: 0,
			width: embedded ? 400 : 1200,
			height: embedded ? 260 : 700,
			margin: embedded ? 0.05 : 0.1,
			minScale: 0.2,
			maxScale: 2.0,
			transition: 'slide',
			backgroundTransition: 'fade',
			scrollActivationWidth: 0,
		});
		reveal.initialize().then(() => {
			if (embedded) return;
			window.addEventListener('message', onMainMessage);
			reveal.on('slidechanged', pushToSpeaker);
			reveal.on('fragmentshown', pushToSpeaker);
			reveal.on('fragmenthidden', pushToSpeaker);
			window.addEventListener('keydown', onSecretKey);
		});
	});

	onDestroy(() => {
		window.removeEventListener('message', onMainMessage);
		window.removeEventListener('keydown', onSecretKey);
		if (speakerWin && !speakerWin.closed) speakerWin.close();
		if (reveal) reveal.destroy();
		if (styleEl) styleEl.remove();
	});
</script>

<div class="reveal-wrapper" class:embedded class:fullscreen={!embedded} class:dark-theme={deck.darkTheme}>
	<div class="reveal" bind:this={container}>
		<div class="slides">
			{#each deck.slides as slide, i}
				{#if slide.verticalSlides}
					<section>
						<section data-background-color={slide.background ?? (i === 0 ? deck.color : (deck.darkTheme ? '#1a1a2e' : '#ffffff'))} data-background-image={slide.backgroundImage} data-background-size="cover" data-background-video={slide.backgroundVideo} data-background-video-loop={slide.backgroundVideo ? '' : undefined} data-background-video-muted={slide.backgroundVideo ? '' : undefined}>
							{#if slide.title}
								<h2 style={deck.darkTheme ? 'color:#e8e8f0;' : (i === 0 ? 'color:#fff;' : `color:${deck.color};`)}>{slide.title}</h2>
							{/if}
							<div class="slide-content" style={deck.darkTheme ? 'color:#e8e8f0;' : (i === 0 ? 'color:#fff;' : '')}>
								{@html slide.content}
							</div>
						{#if slide.notes}<aside class="notes">{@html slide.notes}</aside>{/if}
						</section>
						{#each slide.verticalSlides as vSlide}
							<section data-background-color={vSlide.background ?? (deck.darkTheme ? '#1a1a2e' : '#ffffff')} data-background-image={vSlide.backgroundImage} data-background-size="cover" data-background-video={vSlide.backgroundVideo} data-background-video-loop={vSlide.backgroundVideo ? '' : undefined} data-background-video-muted={vSlide.backgroundVideo ? '' : undefined}>
								{#if vSlide.title}
									<h2 style={deck.darkTheme ? 'color:#e8e8f0;' : `color:${deck.color};`}>{vSlide.title}</h2>
								{/if}
								<div class="slide-content" style={deck.darkTheme ? 'color:#e8e8f0;' : ''}>
									{@html vSlide.content}
								</div>
							{#if vSlide.notes}<aside class="notes">{@html vSlide.notes}</aside>{/if}
							</section>
						{/each}
					</section>
				{:else}
					<section data-background-color={slide.background ?? (i === 0 ? deck.color : (deck.darkTheme ? '#1a1a2e' : '#ffffff'))} data-background-image={slide.backgroundImage} data-background-size="cover" data-background-video={slide.backgroundVideo} data-background-video-loop={slide.backgroundVideo ? '' : undefined} data-background-video-muted={slide.backgroundVideo ? '' : undefined}>
						{#if slide.title}
							<h2 style={deck.darkTheme ? 'color:#e8e8f0;' : (i === 0 ? 'color:#fff;' : `color:${deck.color};`)}>{slide.title}</h2>
						{/if}
						<div class="slide-content" style={deck.darkTheme ? 'color:#e8e8f0;' : (i === 0 ? 'color:#fff;' : '')}>
							{@html slide.content}
						</div>
						{#if slide.notes}<aside class="notes">{@html slide.notes}</aside>{/if}
					</section>
				{/if}
			{/each}
		</div>
	</div>
</div>

<style>
	.reveal-wrapper {
		position: relative;
	}

	.reveal-wrapper.embedded {
		width: 100%;
		height: 260px;
		border-radius: 6px;
		overflow: hidden;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	}

	.reveal-wrapper.fullscreen {
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
		background: #fff;
	}

	.reveal-wrapper .reveal {
		width: 100%;
		height: 100%;
	}

	.reveal-wrapper.embedded :global(.reveal .slides) {
		text-align: left;
	}

	.reveal-wrapper.embedded :global(.reveal .slides h2) {
		font-family: lvwr-ubuntu-thin, sans-serif;
		font-size: 1em;
		margin-bottom: 0.2em;
	}

	.reveal-wrapper.embedded :global(.reveal .slides .slide-content) {
		font-size: 0.55em;
	}

	.reveal-wrapper.fullscreen :global(.reveal .slides h2) {
		font-family: lvwr-ubuntu-thin, sans-serif;
		font-size: 1.8em;
		margin-bottom: 0.5em;
	}

	.reveal-wrapper.fullscreen :global(.reveal .slides .slide-content) {
		font-size: 0.7em;
		text-align: left;
	}

	.reveal-wrapper.fullscreen :global(.reveal .slides ul) {
		display: block;
		margin-left: 1em;
	}

	.reveal-wrapper.fullscreen :global(.reveal .slides li) {
		margin-bottom: 0.5em;
		line-height: 1.4;
	}

	/* Dark theme */
	.reveal-wrapper.dark-theme.fullscreen {
		background: #1a1a2e;
	}

	.reveal-wrapper.dark-theme.embedded {
		background: #1a1a2e;
	}

	.reveal-wrapper.dark-theme :global(.reveal .slides h2) {
		font-family: 'DM Sans', sans-serif;
		color: #e8e8f0;
	}

	.reveal-wrapper.dark-theme :global(.reveal .slides .slide-content) {
		font-family: 'DM Sans', sans-serif;
	}

	.reveal-wrapper.dark-theme.fullscreen :global(.reveal .slides .slide-content) {
		text-align: left;
	}
</style>
